import { Pipe, PipeTransform } from '@angular/core';
import { ExtratoModel } from '../../_models/extratoFiltro.model'
import { StringUtils } from 'src/app/utils/string-utils';

@Pipe({
  name: 'extratoFilter'
})
export class ExtratoFilterPipe implements PipeTransform {

  transform(lista: any[], operacao: string): ExtratoModel[] {
    if (!operacao || !lista) {
      return lista;
    }

    return lista.filter(item =>
      StringUtils.normalizarTexto(item.operacao).includes(StringUtils.normalizarTexto(operacao))
    );
  }

}
